import { Box, Stack, Typography } from '@mui/material'
import { addTipEngagementMetric } from 'api/metrics'
import { useAuthContext } from 'components/context/AuthProvider'
import DrawerHeader from 'components/drawer/common/DrawerHeader'
import { ArticleAudioUserView } from 'features/Article/components/ArticleAudioUserView/ArticleAudioUserView'
import { ArticlePreview } from 'features/Article/components/ArticlePreview/ArticlePreview'
import { UILearnArticleImg } from 'features/UI'
import { useCallback } from 'react'
import { useMetric } from 'services/Metric'
import { IMetricScope, IMetricType, Tip } from 'types'
import { formatDate, formatMetricDate } from 'utils'

export function TipDrawerViewContent({
  data,
  handleClose,
}: {
  data: Tip
  handleClose: () => void
}) {
  const { user } = useAuthContext()

  const handleSaveMetric = useCallback(
    async (value: number) => {
      if (!user) {
        return
      }

      await addTipEngagementMetric({
        tipId: data.id,
        engagedFrom: formatMetricDate(value),
        engagedTo: formatMetricDate(),
      })
    },
    [data, user],
  )

  useMetric({
    type: IMetricType.tip,
    scope: IMetricScope.tip,
    entityId: data.id,
    hasIdleTimer: true,
    idleLimitMin: 2,
    onSave: handleSaveMetric,
  })

  return (
    <>
      <DrawerHeader handleClose={handleClose}>
        <UILearnArticleImg />
        <span>Tip</span>
      </DrawerHeader>

      <Typography variant="h4">{data.name}</Typography>
      <Stack direction="row" gap={1}>
        <Typography color="textSecondary" variant="body1">
          {`by ${data.updater?.firstname} ${data.updater?.lastname} ·
                ${formatDate(data.createdAt, 'h:mm A dddd Do of MMMM, YYYY')}`}
        </Typography>
      </Stack>

      <ArticleAudioUserView
        enMediaUrl={data.enMediaUrl}
        enMediaFileMimeType={data.enMediaFile?.mimeType}
        esMediaUrl={data.esMediaUrl}
        esMediaFileMimeType={data.esMediaFile?.mimeType}
        metricType={IMetricType.tip}
        metricEntityId={data.id}
        onSaveMetric={handleSaveMetric}
      />

      {data.note && (
        <Box my={2} fontSize={20}>
          <Typography variant="body1">Note</Typography>
          <Stack direction="row" gap={1}>
            <Typography color="textSecondary" variant="body1">
              {data.note}
            </Typography>
          </Stack>
        </Box>
      )}

      <Box my={2} fontSize={20} minHeight="128px">
        <ArticlePreview data={data.article} />
      </Box>
    </>
  )
}
